<template>
  <div
    id="bufferbar"
    style="border-radius: 4px; width: 40px;"
    class="elevation-2"
  >
    <v-tooltip
      right
      :open-delay="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Tegn buffer"
          aria-label="Tegn buffer"
          class="zoom-button"
          text
          v-bind="attrs"
          v-on="on"
          v-on:click="Buffer()"
        >
          <v-icon>mdi-circle-outline</v-icon>
        </v-btn>
      </template>
      <span>Avgrens utvalg med buffer rundt et gitt punkt</span>
    </v-tooltip>
    <div
      v-show="bufferset"
      class="slidecontainer"
    >

      <v-slider
        v-model="bufferSize"
        @input="bufferSizeChanging"
        @end="bufferSizeChanged"
        vertical aria-label="test"
        min="1"
        max="99"
        step="5"
      ></v-slider>
      <label class="text-caption pl-2">{{this.bufferSize}}km</label>

      <v-tooltip
        :open-delay="500"
        right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            title="Fjern buffer"
            aria-label="Fjern buffer"
            text
            v-bind="attrs"
            v-on="on"
            class="zoom-button"
            depressed
            @click="Erase()"
            type="button"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <span>Fjern buffer</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapActions, mapState } from "vuex";

export default {
  name: "MapBuffer",
  props: ["kartview", "bufferlayer"],
  data () {
    return {
      bufferAktiv: false,
      bufferset: false,
      bufferSize: 5,
      setBufferPoint: null,
      tempGraphicsLayer: null,
      polySym: {
        type: "simple-fill",
        outline: {
          style: "solid",
          width: 4,
          color: [0, 112, 255, 1]
        },
        color: [0, 197, 255, 0.04]
      }
    };
  },
  computed: {
    ...mapState(["useMapExtent", "activeGeographicFilterMode", "geographicFilterOptions"])
  },
  watch: {
    activeGeographicFilterMode: function () {
      if (this.activeGeographicFilterMode !== this.geographicFilterOptions[3]) {
        this.Erase();
      }
    }
  },
  methods: {
    ...mapActions(["setBufferSettings"]),
    bufferSizeChanged: function () {
      this.updateBuffer();
    },
    bufferSizeChanging: function () {
      this.updateGraphic();
    },
    Buffer: function () {
      this.bufferAktiv = true;
      this.bufferset = true;
    },
    Erase: function () {
      this.bufferAktiv = false;
      this.bufferset = false;
      this.$eventHub.$emit("buffer:oppdatert", false);
      this.setBufferSettings(null);
      this.clearGraphics();
    },
    updateBuffer: function () {
      this.bufferPoint(this.setBufferPoint, this.bufferSize);
      this.setBufferSettings({
        distance: this.bufferSize,
        point: this.setBufferPoint
      });
      this.$eventHub.$emit("buffer:oppdatert", true, {
        distance: this.bufferSize,
        point: this.setBufferPoint
      });
    },
    bufferPoint (point, bufferSize) {
      loadModules([
        "esri/Graphic",
        "esri/geometry/geometryEngine"
      ])
        .then(([Graphic, geometryEngine]) => {
          this.clearGraphics();
          if (point) {
            point.hasZ = false;
            point.z = undefined;

            let buffer = geometryEngine.buffer(
              point,
              bufferSize,
              "kilometers"
            );

            this.tempGraphicsLayer.add(
              new Graphic({
                geometry: buffer,
                symbol: this.polySym
              })
            );
          }

        })
    },
    createBuffer: function (event, view, bufferSize) {
      var point = view.toMap({
        x: event.x,
        y: event.y
      });
      this.setBufferPoint = point;
      if (point) {
        this.bufferPoint(point, bufferSize);
      }
    },
    clearGraphics: function () {
      this.tempGraphicsLayer.removeAll();
    },
    updateGraphic: function () {
      this.bufferPoint(this.setBufferPoint, this.bufferSize);
    }
  },
  mounted: function () {
    this.tempGraphicsLayer = this.bufferlayer;

    this.kartview.on(
      "pointer-move",
      (event) => {
        if (this.bufferAktiv) {
          this.createBuffer(event, this.kartview, this.bufferSize);
        }
      }
    );

    this.kartview.on(
      "immediate-click",
      function (event) {
        if (this.bufferAktiv) {
          this.bufferAktiv = false;
          this.setBufferSettings({
            distance: this.bufferSize,
            point: this.setBufferPoint
          });
          this.$eventHub.$emit("buffer:oppdatert", true, {
            distance: this.bufferSize,
            point: this.setBufferPoint
          });
          event.stopPropagation();
        }
      }.bind(this)
    );

  }
};
</script>
<style>
.esri-component.esri-attribution.esri-widget {
  display: none;
}

.slider {
  -webkit-appearance: slider-vertical;
  width: 65px;
  margin-top: 10px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  background: #4caf50;
  cursor: pointer;
}

#bufferbar {
  background: #fff;
  position: absolute;
  height: auto;
}

/* .active {
  background: #0079c1;
  color: #e4e4e4;
} */
</style>
